import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
//import dayjs from 'dayjs';
import { Post, Get, DownloadFile1, Download } from '@/api/Api';
import { GetBaseUrl } from '@/utils/request';
import { ls } from 'vue-lsp';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      Model: {},
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '80px'
            }
          }
        }
      },
      headers: {
        authorization: 'Bearer ' + ls.get(ACCESS_TOKEN)
      },
      uploadurl: GetBaseUrl() + '/api/uploadPrice'
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.loading = true;
        Post("DM/SavePrice", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + '价格';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      if (fId > 0) {
        Get("/DM/GetPrice", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {};
        DMConfig.loading = false;
      }
    };
    const OnUploadChange = info => {
      DMConfig.Model.fFileName = "";
      DMConfig.Model.fFilePath = "";
      console.log(info.file);
      if (info.file.status !== 'uploading') {
        DMConfig.Model.fFilePath = info.file.response.data.fileName;
        DMConfig.Model.fFileName = info.file.name;
        console.log(info.file);
      }
      if (info.file.status === 'done') {
        _message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        _message.error(`${info.file.name} file upload failed.`);
      }
    };
    const OnBeforeUpload = file => {
      // const isJPG = file.type === 'image/jpeg';
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      const extension = testmsg === 'pdf';
      const extension2 = testmsg === 'pdf';
      //const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt2M = true;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!extension && !extension2) {
        _message.error('Upload file can only be pdf format!');
        return false;
      }
      if (!isLt2M) {
        _message.error('上传大小不能超过 2MB!');
      }
      // return isJPG && isLt2M;
      return (extension || extension2) && isLt2M;
    };
    const OnDownload = () => {
      if (DMConfig.Model.fFilePath) {
        DMConfig.loading = true;
        Download(DMConfig.Model.fId).then(res => {
          DMConfig.loading = false;
          DownloadFile1(res, DMConfig.Model.fFileName);
          // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          DMConfig.loading = false;
          _message.error('下载错误：获取文件流错误');
        });
      }
      ///Service/Upload
    };

    return {
      IsShow,
      Open,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm,
      OnUploadChange,
      OnBeforeUpload,
      OnDownload
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};